import { render } from "./Storage_button.vue?vue&type=template&id=4a4b8644&scoped=true"
import script from "./Storage_button.vue?vue&type=script&lang=js"
export * from "./Storage_button.vue?vue&type=script&lang=js"

import "./Storage_button.vue?vue&type=style&index=0&id=4a4b8644&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4b8644"]])

export default __exports__